import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ProductListItemComponent, ProductListItemContext, ProductListItemContextSource, AddedToCartDialogComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-product-list-item',
  templateUrl: './product-eklist-item.component.html',
  styleUrls: ['./product-eklist-item.component.scss'],
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
})
export class ProductEklistItemComponent extends ProductListItemComponent implements  AfterViewInit{

  constructor(protected productListItemContextSource: ProductListItemContextSource) { 
    super(productListItemContextSource);
  }
  @ViewChild(AddedToCartDialogComponent)
  primaryAddedToCartDialogComponent!: AddedToCartDialogComponent;

  ngAfterViewInit() {
    console.log('Values on ngAfterViewInit():');
    console.log("primaryColorSample:", this.primaryAddedToCartDialogComponent);
  } 
}
